<template>
<div class="my-6 py-6 px-1 md:px-2 lg:px-6">
    <slot />
</div>
</template>

<script>
export default {
    name: 'Auth',
}
</script>
